import { createFileRoute } from '@tanstack/react-router'

import { type Product, productSchema } from '@orus.eu/product'

import { LocalLoadingState } from '../../../../../components/molecules/local-loading-state.tsx'
import { CertificateInfoPage } from '../../../../../components/pages/certificate/certificate-info-page.tsx'
import { certificateSearchSchema } from '../../certificate-search-schema.ts'

import { NotFoundPage } from '#/shared/components/not-found-page/not-found-page.tsx'

export const Route = createFileRoute('/s/a/$token/$product')({
  validateSearch: certificateSearchSchema,
  pendingComponent: () => <LocalLoadingState />,
  component: function RouteComponent() {
    const { token, product } = Route.useParams()
    const { lg } = Route.useSearch()

    if (productSchema.allows(product)) {
      return <CertificateInfoPage product={product as Product} token={token} language={lg} />
    }

    return <NotFoundPage />
  },
})
